/**
 * TanStack Query hooks for `linkedin-conversions-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linkedinConversionsApiQueryKeys,
	type CreateLinkedinConversionsApiBody,
	type ListLinkedinConversionsApiResponse,
	type LinkedinConversionsApiRow,
} from "./api";

export function useLinkedinConversionsApiList(): UseQueryResult<ListLinkedinConversionsApiResponse, Error> {
	return useQuery({
		queryKey: linkedinConversionsApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinkedinConversionsApiCreate(): UseMutationResult<LinkedinConversionsApiRow, Error, CreateLinkedinConversionsApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkedinConversionsApiQueryKeys.all });
		},
	});
}

export function useLinkedinConversionsApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkedinConversionsApiQueryKeys.all });
		},
	});
}
